import PropTypes from 'prop-types';
import { DatePicker } from '@3plearning/react-components';
import {
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER,
    SELECTED_CLASS,
    SELECTED_GROUP,
    SELECTED_STUDENT,
    SELECTED_REPORT,
    SELECTED_DATE
} from './filter-constants';

const filterPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
});

const dateFilterPropType = PropTypes.shape({
    type: PropTypes.oneOf(DatePicker.DATE_OPTIONS),
    startDate: PropTypes.string,
    endDate: PropTypes.string
});

const activeFiltersPropType = PropTypes.shape({
    [SELECTED_YEAR_GROUP]: filterPropType,
    [SELECTED_TEACHER]: filterPropType,
    [SELECTED_CLASS]: filterPropType,
    [SELECTED_GROUP]: filterPropType,
    [SELECTED_STUDENT]: filterPropType,
    [SELECTED_REPORT]: filterPropType,
    [SELECTED_DATE]: dateFilterPropType
});

const dropdownItemPropType = PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string
});

const yearGroupPropType = PropTypes.shape({
    id: PropTypes.number,
    year: PropTypes.string
});

const teacherPropType = PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string
});

const classPropType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
});

const studentsByGroupPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    students: PropTypes.arrayOf(dropdownItemPropType)
});

export {
    filterPropType,
    dateFilterPropType,
    activeFiltersPropType,
    yearGroupPropType,
    teacherPropType,
    classPropType,
    studentsByGroupPropType,
    dropdownItemPropType
};



// WEBPACK FOOTER //
// ./components/report-filters/filter-prop-types.js